module.exports = __webpack_public_path__ + "static/media/display16.a2151108.jpg";